import React from "react";
import { Overview } from "pages/Sections/WiFi/Overview";
import withTracker from "util/withTracker";
import { Route, withRouter } from "react-router-dom";

const RouteWrapper = () => {
  return (
    <Route>
      <Overview />
    </Route>
  );
};

export default withRouter(withTracker(RouteWrapper));
